import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { format } from 'date-fns'

import { useGetListItemInsights } from '../../../../features/hooks/useGetListItemInsights'

import { getAds } from '../../../../modules/actions/ads'
import { campaignsSummaryDateRangeSelector } from '../../../../modules/selectors/campaignsSummary'

import { DATES_FORMAT_BE } from '../../../../constants/dates'

const useAdsFetchData = ({ adAccountId, campaignId, lineItemId, platform, withPagination }) => {
  const dispatch = useDispatch()

  const campaignsSummaryDateRange = useSelector(campaignsSummaryDateRangeSelector)
  const { date_preset, startDate, endDate } = campaignsSummaryDateRange

  const insights = useGetListItemInsights(platform)

  return useCallback(
    adsAfter => {
      dispatch(
        getAds(
          {
            campaign_id: campaignId,
            ad_group_id: lineItemId,
            account: adAccountId,
            insights,
            detail: true,
            date_from: startDate && format(startDate, DATES_FORMAT_BE),
            date_to: endDate && format(endDate, DATES_FORMAT_BE),
            date_preset,
            // pagination logic
            ...(withPagination && { limit: 10 }),
            ...(adsAfter && { after: adsAfter })
          },
          platform
        )
      )
    },
    [dispatch, adAccountId, campaignId, insights, lineItemId, platform, withPagination, date_preset, startDate, endDate]
  )
}

export default useAdsFetchData
